import { render, staticRenderFns } from "./ProgrammeOverview.vue?vue&type=template&id=93210038&scoped=true&"
import script from "./ProgrammeOverview.vue?vue&type=script&lang=js&"
export * from "./ProgrammeOverview.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammeOverview.vue?vue&type=style&index=0&id=93210038&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93210038",
  null
  
)

export default component.exports